import { InjectionToken, Signal } from '@angular/core'
import { UserInfo } from '@seiri/shared/common'

/**
 * What the shared account screen needs from the app that mounts it (docs/account.md): the signed-in person, a way to
 * hand back the saved profile so the app's own session (the sidebar initials, localStorage) follows, and the app's
 * way of telling the person how a save went. Each zone - the premise app today, the employee and client zones later -
 * provides one, usually on the route that renders `seiri-account-profile`.
 */
export interface AccountHost {
  readonly user: Signal<UserInfo | null>
  setUser(user: UserInfo): void
  /** Keeps this session signed in after a password change, which ends every session older than the change. */
  setToken(accessToken: string): void
  /** `error` is the caught error, so an `ApiError` can be worded by its code; `text` is the fallback. */
  notify(outcome: 'success' | 'error', text: string, error?: unknown): void
}

export const ACCOUNT_HOST = new InjectionToken<AccountHost>('ACCOUNT_HOST')
